/**
 * Algolia Inline Search
 *
 * LIVE — loaded from theme.liquid ("Algolia Inline Search" block).
 * 30 Oct 2026: product_type facet relabelled "Type" (matches the storefront Type filter);
 * new "Category" facet built from category tags (tags that match a collection handle).
 *
 * Behaviour:
 * - User types in the header search bar
 * - Page content below header hides, Algolia results appear in its place
 * - Filters (Brand, Category) on left — Products on right
 * - Clearing the search box restores the original page content
 * - No autocomplete dropdown while inline search is active
 */

(function () {
  'use strict';

  /* ── Configuration ─────────────────────────────────────────── */
  var CONFIG = {
    appId:        'NBQ8FE3KAM',
    searchApiKey: '65b4715a1ded1cc4947882de70b8c859',
    indexName:    'shopify_products',
    hitsPerPage:  50
  };

  /* ── Styles ─────────────────────────────────────────────────── */
  var CSS = [
    'store-header,sticky-header{--menu-height:88px!important;}',
    '#ais-header-wrap{display:block;width:100%;position:relative;background:#fff;}',
    '#algolia-inline-search{display:none;padding:24px 20px;box-sizing:border-box;width:100%;}',

    'body.ais-inline-on sticky-header,body.ais-inline-on store-header,body.ais-inline-on .shopify-section-header,body.ais-inline-on #shopify-section-header,body.ais-inline-on header.site-header,body.ais-inline-on header.header__grid,body.ais-inline-on .header__grid{position:sticky!important;top:0!important;z-index:9999!important;}',
    '#algolia-inline-search.ais-active{display:flex;gap:24px;align-items:flex-start;width:100%;max-width:calc(var(--page-width,1320px) + var(--gutter)*2);margin:30px auto;padding:0 var(--gutter);}',
    '#algolia-inline-facets{width:280px;flex-shrink:0;position:sticky;top:80px;max-height:calc(100vh - 100px);overflow-y:auto;scrollbar-width:thin;scrollbar-color:#e0e0e0 transparent;}',
    '#algolia-inline-facets::-webkit-scrollbar{width:6px;}',
    '#algolia-inline-facets::-webkit-scrollbar-track{background:transparent;}',
    '#algolia-inline-facets::-webkit-scrollbar-thumb{background:#e0e0e0;border-radius:3px;}',
    '#algolia-inline-facets:hover{scrollbar-color:#bbb transparent;}',
    '#algolia-inline-facets:hover::-webkit-scrollbar-thumb{background:#bbb;}',
    '#algolia-inline-results{flex:1;min-width:0;}',
    '#algolia-inline-hits img{width:95%!important;height:95%!important;max-width:none!important;object-fit:contain!important;}',

    /* Panel */
    '.ais-Panel{border:1px solid #e5e5e5;border-radius:6px;margin-bottom:16px;overflow:hidden;background:#fff;}',
    '.ais-Panel-header{display:flex;align-items:center;justify-content:space-between;padding:12px 14px;background:#f5f5f5;cursor:pointer;user-select:none;}',
    '.ais-Panel-header span{font-size:14px;font-weight:700;color:#111;}',

    /* Hide Algolia's built-in collapse button — we use CSS ::after instead */
    '.ais-Panel-collapseButton{display:none!important;}',

    /* Our accordion indicator via CSS pseudo-element on the header */
    /* Default (open): show ∧ */
    '.ais-Panel-header::after{content:"∧";font-size:14px;color:#333;line-height:1;flex-shrink:0;}',
    /* Closed state: facet container gets ais-facet-closed class */
    '.ais-facet-closed .ais-Panel-header::after{content:"∨";}',

    '.ais-Panel-body{padding:12px 14px;}',
    /* Body hidden when container is closed — !important wins over Algolia's own styles */
    '.ais-facet-closed .ais-Panel-body{display:none!important;}',

    /* RefinementList */
    '.ais-RefinementList-list{list-style:none;padding:0;margin:0;}',
    '.ais-RefinementList-item{margin-bottom:8px;}',
    '.ais-RefinementList-label{display:flex;align-items:center;gap:8px;cursor:pointer;font-size:13px;color:#333;}',
    '.ais-RefinementList-checkbox{width:15px;height:15px;cursor:pointer;flex-shrink:0;}',
    '.ais-RefinementList-item--selected .ais-RefinementList-label{font-weight:700;color:#20245c;}',
    '.ais-RefinementList-labelText{flex:1;}',
    '.ais-RefinementList-count{background:none;border:none;border-radius:0;padding:0;font-size:13px;color:#666;}',
    '.ais-RefinementList-count::before{content:"(";}',
    '.ais-RefinementList-count::after{content:")";}',
    '.ais-RefinementList-showMore{margin-top:8px;font-size:13px;color:#333;background:none;border:none;cursor:pointer;padding:0;text-decoration:underline;display:block;}',

    /* Stats */
    '#algolia-inline-stats{font-size:13px;color:#666;margin-bottom:0;margin-right:auto;}',

    /* Grid */
    '#algolia-inline-hits .ais-Hits-list{display:grid;grid-template-columns:repeat(4,1fr);gap:16px;list-style:none;padding:0;margin:0;align-items:stretch;}',
    '#algolia-inline-hits .ais-Hits-list>li{display:flex;align-items:stretch;position:relative;}',
    '#algolia-inline-hits .ais-Hits-list>li>.ais-inline-hit-wrap{width:100%;}',
    '#algolia-inline-hits .ais-Hits-list>li .ais-inline-hit{border-bottom-left-radius:0;border-bottom-right-radius:0;}',
    '@media(min-width:1400px){#algolia-inline-hits .ais-Hits-list{grid-template-columns:repeat(4,1fr);}}',
    '@media(max-width:900px){#algolia-inline-hits .ais-Hits-list{grid-template-columns:repeat(3,1fr);}}',
    '@media(max-width:900px){body.ais-inline-on store-header{z-index:unset!important;}}',

    '@media(max-width:768px){#algolia-inline-search.ais-active{flex-direction:column;padding:12px;}#algolia-inline-facets{display:none;}#algolia-inline-hits .ais-Hits-list{grid-template-columns:repeat(2,1fr);}}',
    '@media(max-width:768px){body.ais-inline-on store-header,body.ais-inline-on sticky-header,body.ais-inline-on .shopify-section-group-header-group,body.ais-inline-on #shopify-section-header{display:none!important;}}',

    /* Filter drawer */
    '#ais-filter-drawer{display:none;position:fixed;inset:0;z-index:99999;background:rgba(0,0,0,.45);}',
    '#ais-filter-drawer.open{display:block;}',
    '#ais-filter-drawer__panel{position:absolute;top:0;left:0;bottom:0;width:82vw;max-width:320px;background:#fff;overflow-y:auto;-webkit-overflow-scrolling:touch;padding:16px;}',
    '#ais-filter-drawer__close{position:sticky;top:0;display:flex;justify-content:flex-end;margin-bottom:8px;background:#fff;z-index:1;}',
    '#ais-filter-drawer__close button{background:none;border:1px solid #ccc;border-radius:50%;width:32px;height:32px;font-size:18px;cursor:pointer;display:flex;align-items:center;justify-content:center;}',

    /* Mobile top bar */
    '#ais-mobile-bar{display:none;align-items:center;gap:10px;margin-bottom:12px;}',
    '@media(max-width:768px){#ais-mobile-bar{display:flex;}}',
    '#ais-filter-btn{flex:1;padding:9px 16px;background:#20245c;color:#fff;border:none;border-radius:6px;font-size:14px;font-weight:700;cursor:pointer;}',
    '#ais-search-close-btn{width:38px;height:38px;background:#f5f5f5;border:1px solid #ddd;border-radius:50%;font-size:20px;cursor:pointer;display:flex;align-items:center;justify-content:center;flex-shrink:0;}',

    /* Desktop close X */
    '#ais-desktop-close{display:none;position:absolute;top:16px;right:20px;}',
    '@media(min-width:769px){#ais-desktop-close{display:block;}}',
    '#ais-desktop-close button{width:36px;height:36px;background:#f5f5f5;border:1px solid #ddd;border-radius:50%;font-size:20px;cursor:pointer;display:flex;align-items:center;justify-content:center;}',

    '@media(max-width:768px){#algolia-inline-search.ais-active{position:fixed;left:0;right:0;bottom:0;z-index:9999;overflow-y:auto;-webkit-overflow-scrolling:touch;background:#fff;padding-top:8px;border-top:1px solid #e0e0e0;}}',
    '@media(max-width:768px){#ais-filter-drawer{z-index:9000;}}',

    /* Hit card */
    '.ais-inline-hit{display:flex;flex-direction:column;width:100%;height:100%;text-decoration:none;color:inherit;box-sizing:border-box;overflow:hidden;transition:box-shadow .2s;background:#fff;}',
    '.ais-inline-hit__img-wrap{position:relative;aspect-ratio:1;display:flex;align-items:center;justify-content:center;overflow:hidden;flex-shrink:0;}',
    '.ais-inline-hit__img-wrap img{max-width:100%;max-height:100%;object-fit:contain;}',

    '.ais-inline-badge{position:absolute;bottom:8px;right:8px;background:#20245c;border-radius:50%;width:62px;height:62px;display:flex;flex-direction:column;align-items:center;justify-content:center;z-index:2;}',
    '.ais-inline-badge__price{color:#f6eb0e;font-size:14px;font-weight:700;text-align:center;line-height:1.2;}',
    '.ais-inline-badge__was{color:rgba(255,255,255,.8);font-size:11px;text-decoration:line-through;text-align:center;line-height:1.2;}',

    '#ais-sort-by select{font-size:13px;padding:6px 10px;border:1px solid #ddd;border-radius:6px;background:#fff;color:#333;cursor:pointer;}',
    '.ais-inline-save{font-size:10px;font-weight:700;color:#e43f3f;text-align:center;padding:3px 0;}',
    '.ais-inline-hit__body{padding:10px;flex:1;display:flex;flex-direction:column;}',
    '.ais-inline-hit__brand{display:none;font-size:11px;color:#888;top:2px;right:2px;position:absolute;background:#fff;padding:5px;border-radius:10px;border:1px solid #d1cbcb;box-shadow:0 2px 6px rgba(0,0,0,.12);z-index:3;}',
    '.ais-inline-hit__title{font-size:15px;font-weight:700;font-family:"PT Sans",sans-serif;text-align:center;color:#111;line-height:1.5;margin-bottom:6px;}',
    '.ais-inline-hit__price-plain{font-size:14px;font-weight:700;color:#20245c;}',
    '#algolia-inline-hits img.ais-inline-vendor-logo{width:auto!important;height:auto!important;max-height:33px!important;max-width:80px!important;object-fit:contain!important;display:block;}',

    '.ais-inline-atc{display:block;margin:auto;padding:var(--btn-padding-y,12px) 26px;font-family:"PT Sans","Helvetica Neue",Helvetica,Arial,sans-serif;font-size:.88em;font-weight:700;text-transform:uppercase;text-align:center;color:#f6eb0e;background:#20245c;border:1px solid #20245c;border-radius:3px;cursor:pointer;transition:background .15s;letter-spacing:.5px;flex-shrink:0;}',
    '.ais-inline-atc:hover{background:#33c!important;border-color:#33c!important;}',
    '.ais-inline-atc.adding{opacity:.6;pointer-events:none;}',
    '.ais-inline-atc.added{background:#2a7a2a!important;border-color:#2a7a2a!important;color:#fff!important;}',
    '.ais-inline-no-results{text-align:center;padding:48px 20px;color:#666;font-size:15px;}',

    '#algolia-inline-pagination{margin-top:28px;display:flex;justify-content:center;}',
    '.ais-Pagination-list{display:flex;list-style:none;padding:0;margin:0;gap:6px;}',
    '.ais-Pagination-link{padding:6px 12px;border:1px solid #ddd;border-radius:4px;color:#20245c;text-decoration:none;font-size:13px;}',
    '.ais-Pagination-item--selected .ais-Pagination-link{background:#20245c;color:#fff;border-color:#20245c;}',
    '.ais-Pagination-item--disabled .ais-Pagination-link{opacity:.4;pointer-events:none;}',

    'body.ais-inline-on .aa-Panel,body.ais-inline-on .aa-DetachedOverlay{display:none!important;}',

    /* noUiSlider custom styles */
    '.noUi-target,.noUi-target *{-webkit-user-select:none;user-select:none;touch-action:none;box-sizing:border-box;}',
    '.noUi-target{position:relative;}',
    '.noUi-base,.noUi-connects{width:100%;height:100%;position:relative;z-index:1;}',
    '.noUi-connects{overflow:hidden;z-index:0;}',
    '.noUi-connect,.noUi-origin{will-change:transform;position:absolute;z-index:1;top:0;right:0;height:100%;width:100%;transform-origin:0 0;}',
    '.noUi-horizontal{height:2px;background:#333;border-radius:2px;border:none;box-shadow:none;margin:18px 10px 12px;}',
    '.noUi-horizontal .noUi-handle{width:22px;height:22px;right:-11px;top:-11px;}',
    '.noUi-connect{background:#333;}',
    '.noUi-handle{position:absolute;box-sizing:border-box;background:#fff;border:2px solid #333;border-radius:50%;cursor:pointer;box-shadow:none;}',
    '.noUi-handle::before,.noUi-handle::after{display:none;}',
    /* Price range inputs */
    '.ais-price-row{display:flex;align-items:center;gap:6px;}',
    '.ais-price-field{display:flex;align-items:center;border:1px solid #ddd;border-radius:6px;padding:7px 10px;flex:1;background:#fff;}',
    '.ais-price-dollar{color:#bbb;font-size:13px;margin-right:2px;flex-shrink:0;}',
    '.ais-price-input{border:none;outline:none;width:100%;font-size:13px;color:#333;background:transparent;-moz-appearance:textfield;padding:0;}',
    '.ais-price-input::-webkit-inner-spin-button,.ais-price-input::-webkit-outer-spin-button{-webkit-appearance:none;}',
    '.ais-price-input::placeholder{color:#bbb;}',
    '.ais-price-dash{color:#999;font-size:13px;flex-shrink:0;}',

    /* Mobile full-screen overlay */
    '#ais-mobile-overlay{display:none;position:fixed;inset:0;z-index:99999;flex-direction:column;background:#fff;overflow:hidden;}',
    '#ais-mobile-overlay.ais-open{display:flex;}',
    '#ais-mobile-searchbar{display:flex;flex-shrink:0;align-items:center;gap:8px;padding:10px 12px;border-bottom:1px solid #e0e0e0;background:#fff;}',
    '#ais-mobile-search-input{flex:1;padding:10px 14px;font-size:16px;border:1px solid #ccc;border-radius:8px;box-sizing:border-box;outline:none;-webkit-appearance:none;}',
    '#ais-mobile-cancel-btn{flex-shrink:0;padding:8px 4px;background:none;border:none;color:#20245c;font-size:14px;font-weight:600;cursor:pointer;white-space:nowrap;}',
    '#ais-mobile-overlay #algolia-inline-search{position:static!important;top:auto!important;display:flex!important;flex:1;overflow-y:auto;-webkit-overflow-scrolling:touch;flex-direction:column;padding:12px;background:#fff;}'
  ].join('');

  /* ── Helpers ────────────────────────────────────────────────── */
  var vendorLogos = {};
  var collectionTitles = {}; /* collection handle -> title, for the Category facet (category tags mirror collection handles) */
  /* Category tags whose spelling differs from the collection handle */
  var CATEGORY_TAG_ALIAS = { 'barwine-fridges': 'bar-wine-fridges', 'built-in-wall-electric-ovens': '600mm-built-in-electric-wall-ovens', 'freestanding-gasgas-ovens': 'freestanding-gas-gas-ovens', 'hifi-and-soundbars': 'hifi-soundbars', 'hot-and-cold-filter-taps': 'hot-cold-filter-taps', 'oven-accessories': 'ovens-accessories', 'pull-out-mixer-taps': 'pull-out-taps', 'sink-and-tap-accessories': 'sink-accessories' };
  var CATEGORY_TAG_EXCLUDE = { 'sydney-only-delivery': 1, 'next-day-delivery-smart-collection': 1, 'all': 1, 'clearance': 1, 'smeg-clearance': 1, 'whitegoods': 1, 'ovens': 1, 'cooktops': 1, 'rangehoods': 1, 'microwaves': 1, 'dishwashers': 1, 'sinks-taps': 1, 'heating-cooling': 1, 'tvs-audio': 1 };
  var stickerProductIds = {}; /* set of product IDs in next-day-delivery collection */

  function handleize(str) {
    return (str || '').toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '');
  }

  function fetchStickerCollection(callback) {
    try {
      fetch('/collections/next-day-delivery-smart-collection/products.json?limit=250')
        .then(function (r) { return r.json(); })
        .then(function (data) {
          try {
            (data.products || []).forEach(function (p) {
              stickerProductIds[p.id] = true;
            });
          } catch (e) {}
          callback();
        })
        .catch(function () { callback(); });
    } catch (e) { callback(); }
  }

  function fetchVendorLogos(callback) {
    try {
      fetch('/collections.json?limit=250')
        .then(function (r) { return r.json(); })
        .then(function (data) {
          try {
            (data.collections || []).forEach(function (col) {
              if (col.handle && col.title) { collectionTitles[col.handle] = col.title; }
              if (col.handle && col.handle.indexOf('vendor-') === 0 && col.image && col.image.src) {
                vendorLogos[col.handle.replace('vendor-', '')] = col.image.src;
              }
            });
          } catch (e) {}
          callback();
        })
        .catch(function () { callback(); });
    } catch (e) { callback(); }
  }

  function fmt(price) {
    if (!price && price !== 0) return '';
    return '$' + Math.round(price).toLocaleString('en-AU');
  }

  function addToCart(variantId, btn) {
    if (!variantId) return;
    btn.classList.add('adding');
    btn.textContent = 'Adding…';
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: 1 })
    })
      .then(function(r) { return r.json(); })
      .then(function(data) {
        if (data.id) {
          window.location.href = '/cart';
        } else {
          btn.classList.remove('adding');
          btn.textContent = data.description || 'Add to Cart';
          setTimeout(function() { btn.textContent = 'Add to Cart'; }, 2500);
        }
      })
      .catch(function() { btn.classList.remove('adding'); btn.textContent = 'Add to Cart'; });
  }

  function injectStyles() {
    var s = document.createElement('style');
    s.textContent = CSS;
    document.head.appendChild(s);
  }

  /* ── noUiSlider loader ──────────────────────────────────────── */
  function loadNoUiSlider(cb) {
    if (window.noUiSlider) { cb(); return; }
    var s = document.createElement('script');
    s.src = 'https://cdnjs.cloudflare.com/ajax/libs/noUiSlider/15.7.1/nouislider.min.js';
    s.onload  = function () { cb(); };
    s.onerror = function () { cb(); };
    document.head.appendChild(s);
  }

  /* ── Custom Price Range Widget ──────────────────────────────── */
  /* Uses connectRange (not panel HOC) + noUiSlider dual handles  */
  function buildPriceRangeWidget(containerId) {
    var sliderEl = null;
    var minInp   = null;
    var maxInp   = null;
    var lastRefine = null;
    var lastRange  = null;
    var sliderReady = false;

    var renderFn = function (renderState, isFirstRender) {
      var container = document.getElementById(containerId);
      if (!container) return;

      var range  = renderState.range  || { min: 0, max: 21499 };
      var start  = renderState.start  || [-Infinity, Infinity];
      lastRefine = renderState.refine;
      lastRange  = range;

      /* Effective slider positions */
      var lo = (start[0] !== -Infinity && start[0] !== undefined) ? start[0] : range.min;
      var hi = (start[1] !==  Infinity && start[1] !== undefined) ? start[1] : range.max;

      if (isFirstRender) {
        container.innerHTML =
          '<div class="ais-price-row">' +
            '<div class="ais-price-field">' +
              '<span class="ais-price-dollar">$</span>' +
              '<input type="number" class="ais-price-input ais-price-min" placeholder="' + (range.min || 0) + '">' +
            '</div>' +
            '<span class="ais-price-dash">-</span>' +
            '<div class="ais-price-field">' +
              '<span class="ais-price-dollar">$</span>' +
              '<input type="number" class="ais-price-input ais-price-max" placeholder="' + (range.max || 21499) + '">' +
            '</div>' +
          '</div>' +
          '<div class="ais-price-slider-el"></div>';

        sliderEl = container.querySelector('.ais-price-slider-el');
        minInp   = container.querySelector('.ais-price-min');
        maxInp   = container.querySelector('.ais-price-max');

        /* Init slider if noUiSlider already loaded */
        function initSlider() {
          if (sliderReady || !window.noUiSlider || !sliderEl) return;
          sliderReady = true;
          var rMin = lastRange ? (lastRange.min || 0) : 0;
          var rMax = lastRange ? (lastRange.max || 21499) : 21499;
          noUiSlider.create(sliderEl, {
            start: [rMin, rMax],
            connect: true,
            step: 1,
            range: { min: rMin, max: rMax === rMin ? rMin + 1 : rMax }
          });

          /* Update placeholder while dragging — don't fire Algolia */
          sliderEl.noUiSlider.on('update', function (values) {
            if (minInp && document.activeElement !== minInp) {
              minInp.placeholder = Math.round(values[0]);
              if (minInp.value === '') minInp.placeholder = Math.round(values[0]);
            }
            if (maxInp && document.activeElement !== maxInp) {
              maxInp.placeholder = Math.round(values[1]);
              if (maxInp.value === '') maxInp.placeholder = Math.round(values[1]);
            }
          });

          /* Fire refine on handle release */
          sliderEl.noUiSlider.on('change', function (values) {
            var mn = Math.round(values[0]);
            var mx = Math.round(values[1]);
            if (minInp) { minInp.value = ''; minInp.placeholder = mn; }
            if (maxInp) { maxInp.value = ''; maxInp.placeholder = mx; }
            lastRefine && lastRefine([mn, mx]);
          });
        }

        if (window.noUiSlider) {
          initSlider();
        } else {
          /* noUiSlider not yet loaded — retry after bootstrap loads it */
          var retryTimer = setInterval(function () {
            if (window.noUiSlider) { clearInterval(retryTimer); initSlider(); }
          }, 100);
        }

        /* Input → refine */
        var inputTimer;
        function onInputChange() {
          clearTimeout(inputTimer);
          inputTimer = setTimeout(function () {
            var mn = parseFloat(minInp.value);
            var mx = parseFloat(maxInp.value);
            var rMin = lastRange ? lastRange.min : 0;
            var rMax = lastRange ? lastRange.max : 21499;
            if (isNaN(mn)) mn = rMin;
            if (isNaN(mx)) mx = rMax;
            if (sliderEl && sliderEl.noUiSlider) sliderEl.noUiSlider.set([mn, mx], false);
            lastRefine && lastRefine([mn, mx]);
          }, 600);
        }
        minInp.addEventListener('change', onInputChange);
        maxInp.addEventListener('change', onInputChange);

      } else {
        /* Subsequent renders: sync slider + placeholders with Algolia state */
        if (minInp) minInp.placeholder = range.min || 0;
        if (maxInp) maxInp.placeholder = range.max || 21499;

        var isMinDefault = lo === range.min;
        var isMaxDefault = hi === range.max;
        if (minInp) minInp.value = isMinDefault ? '' : lo;
        if (maxInp) maxInp.value = isMaxDefault ? '' : hi;

        if (sliderEl && sliderEl.noUiSlider) {
          var rMin2 = range.min || 0;
          var rMax2 = range.max || 21499;
          sliderEl.noUiSlider.updateOptions(
            { range: { min: rMin2, max: rMax2 === rMin2 ? rMin2 + 1 : rMax2 } },
            true
          );
          sliderEl.noUiSlider.set([lo, hi], false);
        }
      }
    };

    var customWidget = instantsearch.connectors.connectRange(renderFn);
    return customWidget({ attribute: 'price' });
  }

  function buildContainer() {
    var el = document.createElement('div');
    el.id = 'algolia-inline-search';
    el.style.position = 'relative';
    el.innerHTML =
      '<div id="ais-desktop-close"><button id="ais-desktop-close-btn" aria-label="Close search">&#x2715;</button></div>' +
      '<div id="ais-mobile-bar">' +
        '<button id="ais-filter-btn">&#9776; Filters</button>' +
        '<button id="ais-search-close-btn" aria-label="Close search">&#x2715;</button>' +
      '</div>' +
      '<div id="algolia-inline-facets">' +
        '<div id="ais-facets-price"></div>' +
        '<div id="ais-facets-vendor"></div>' +
        '<div id="ais-facets-category"></div>' +
        '<div id="ais-facets-type"></div>' +
        '<div id="ais-facets-width"></div>' +
        '<div id="ais-facets-depth"></div>' +
        '<div id="ais-facets-installation"></div>' +
        '<div id="ais-facets-warranty"></div>' +
      '</div>' +
      '<div id="algolia-inline-results">' +
        '<div id="ais-results-header" style="display:flex;align-items:center;justify-content:space-between;margin-bottom:14px;">' +
          '<div id="algolia-inline-stats"></div>' +
          '<div id="ais-sort-by"></div>' +
        '</div>' +
        '<div id="algolia-inline-hits"></div>' +
        '<div id="algolia-inline-pagination"></div>' +
      '</div>' +
      '<div id="ais-filter-drawer">' +
        '<div id="ais-filter-drawer__panel">' +
          '<div id="ais-filter-drawer__close"><button aria-label="Close filters">&#x2715;</button></div>' +
          '<div id="ais-facets-price-mobile"></div>' +
          '<div id="ais-facets-vendor-mobile"></div>' +
          '<div id="ais-facets-category-mobile"></div>' +
          '<div id="ais-facets-type-mobile"></div>' +
          '<div id="ais-facets-width-mobile"></div>' +
          '<div id="ais-facets-depth-mobile"></div>' +
          '<div id="ais-facets-installation-mobile"></div>' +
          '<div id="ais-facets-warranty-mobile"></div>' +
        '</div>' +
      '</div>';
    return el;
  }

  var SEARCH_SELECTOR = 'input[name="q"],[data-predictive-search-input],.search-modal__input,.search__input,input[type="search"]';

  /* ── Accordion ──────────────────────────────────────────────── */
  function setupAccordion(containerEl) {
    if (!containerEl || containerEl._accordionDone) return;
    containerEl._accordionDone = true;

    containerEl.querySelectorAll('[id^="ais-facets-"]').forEach(function (facetEl) {
      facetEl.classList.add('ais-facet-closed');
    });

    containerEl.addEventListener('click', function (e) {
      var hdr = e.target.closest('.ais-Panel-header');
      if (!hdr) return;
      var panelEl = hdr.closest('.ais-Panel');
      if (!panelEl) return;
      var facetEl = panelEl.parentElement;
      if (!facetEl) return;

      var isClosed = facetEl.classList.contains('ais-facet-closed');

      if (!isClosed) {
        facetEl.classList.add('ais-facet-closed');
      } else {
        containerEl.querySelectorAll('[id^="ais-facets-"]').forEach(function (el) {
          el.classList.add('ais-facet-closed');
        });
        facetEl.classList.remove('ais-facet-closed');
      }
    });
  }

  /* ── Main init ──────────────────────────────────────────────── */
  function init() {
    var mainContent = document.querySelector('#MainContent, main');
    if (!mainContent) { console.warn('[Algolia Inline] #MainContent not found'); return; }

    var panel = buildContainer();
    var storeHdr =
      document.querySelector('store-header') ||
      document.querySelector('sticky-header') ||
      document.querySelector('.shopify-section-group-header-group') ||
      document.querySelector('#shopify-section-header');
    if (storeHdr && storeHdr.parentNode) {
      var wrapper = document.createElement('div');
      wrapper.id = 'ais-header-wrap';
      storeHdr.parentNode.insertBefore(wrapper, storeHdr);
      wrapper.appendChild(storeHdr);
      wrapper.appendChild(panel);
    } else {
      mainContent.parentNode.insertBefore(panel, mainContent);
    }

    /* ── Price panel structure (panel HOC incompatible with rangeInput) ──
       Must run after panel is in DOM, before search.addWidgets.
       Creates the ais-Panel shell manually so accordion and styles work. */
    function setupPricePanel(containerId, innerDivId) {
      var el = document.getElementById(containerId);
      if (!el) return;
      el.innerHTML =
        '<div class="ais-Panel">' +
          '<div class="ais-Panel-header"><span>Price</span></div>' +
          '<div class="ais-Panel-body"><div id="' + innerDivId + '"></div></div>' +
        '</div>';
    }
    setupPricePanel('ais-facets-price', 'ais-price-range');
    setupPricePanel('ais-facets-price-mobile', 'ais-price-range-mobile');

    var panelOriginalParent = panel.parentNode;
    var drawer       = panel.querySelector('#ais-filter-drawer');
    var filterBtn    = panel.querySelector('#ais-filter-btn');
    var drawerCloseBtn = panel.querySelector('#ais-filter-drawer__close button');
    var mobileCloseBtn = panel.querySelector('#ais-search-close-btn');
    var desktopCloseBtn = panel.querySelector('#ais-desktop-close-btn');

    /* ── Mobile full-screen overlay ── */
    var mobileOverlay = document.createElement('div');
    mobileOverlay.id = 'ais-mobile-overlay';
    var mobileSearchBar = document.createElement('div');
    mobileSearchBar.id = 'ais-mobile-searchbar';
    mobileSearchBar.innerHTML =
      '<input id="ais-mobile-search-input" type="search" placeholder="Search products..."' +
      ' autocomplete="off" autocorrect="off" autocapitalize="off" spellcheck="false">' +
      '<button id="ais-mobile-cancel-btn" type="button">Cancel</button>';
    mobileOverlay.appendChild(mobileSearchBar);
    document.body.appendChild(mobileOverlay);

    var mobileSearchInput = mobileSearchBar.querySelector('input');
    var mobileCancelBtn   = mobileSearchBar.querySelector('#ais-mobile-cancel-btn');
    mobileCancelBtn.addEventListener('click', function() { hideInline(); });

    /* ── Intercept Algolia's search button on mobile ── */
    /* touchstart: only block Algolia's native handler — do NOT open overlay here */
    document.addEventListener('touchstart', function(e) {
      if (window.innerWidth > 768) return;
      var btn = e.target && e.target.closest && e.target.closest('.aa-DetachedSearchButton');
      if (!btn) return;
      e.preventDefault();
      e.stopImmediatePropagation();
    }, { capture: true, passive: false });

    /* touchend: open overlay + focus input here so iOS keyboard appears
       (iOS only shows keyboard from touchend/click user gesture context) */
    document.addEventListener('touchend', function(e) {
      if (window.innerWidth > 768) return;
      var btn = e.target && e.target.closest && e.target.closest('.aa-DetachedSearchButton');
      if (!btn) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      if (!isActive) {
        mobileOverlay.appendChild(panel);
        mobileOverlay.classList.add('ais-open');
        document.body.classList.add('ais-inline-on');
        panel.classList.add('ais-active');
        isActive = true;
        /* Hide results until user actually types */
        var resDiv = panel.querySelector('#algolia-inline-results');
        if (resDiv) resDiv.style.display = 'none';
      }
      mobileSearchInput.value = '';
      mobileSearchInput.focus();
    }, { capture: true, passive: false });

    document.addEventListener('click', function(e) {
      if (window.innerWidth > 768) return;
      var btn = e.target && e.target.closest && e.target.closest('.aa-DetachedSearchButton');
      if (!btn) return;
      e.preventDefault();
      e.stopImmediatePropagation();
    }, true);

    /* ── Keep keyboard open on iOS ── */
    var _mobileRefocusAllowed = true;
    mobileSearchInput.addEventListener('blur', function() {
      if (!isActive || !_mobileRefocusAllowed) return;
      setTimeout(function() { if (isActive && _mobileRefocusAllowed) mobileSearchInput.focus(); }, 80);
    });

    function openDrawer()  { drawer.classList.add('open'); document.body.style.overflow = 'hidden'; }
    function closeDrawer() { drawer.classList.remove('open'); document.body.style.overflow = ''; }
    filterBtn    && filterBtn.addEventListener('click', openDrawer);
    drawerCloseBtn && drawerCloseBtn.addEventListener('click', closeDrawer);
    drawer && drawer.addEventListener('click', function(e) { if (e.target === drawer) closeDrawer(); });

    function makePanel(header) {
      return instantsearch.widgets.panel({
        templates: { header: header },
        /* Hide a filter that has nothing to offer for this search (e.g. a facet not yet enabled in Algolia,
           or a Type/Category with a single value) instead of showing an empty heading. */
        hidden: function (options) { return !options.items || options.items.length < 2; }
      })(instantsearch.widgets.refinementList);
    }

    /* Desktop panels */
    var brandPanel    = makePanel('Brand');
    var categoryPanel = makePanel('Category');
    var typePanel     = makePanel('Type');
    var widthPanel    = makePanel('Width (mm)');
    var depthPanel    = makePanel('Depth (mm)');
    var installPanel  = makePanel('Installation');
    var warrantyPanel = makePanel('Manufacturer Warranty');

    /* Mobile panels */
    var brandPanelM    = makePanel('Brand');
    var categoryPanelM = makePanel('Category');
    var typePanelM     = makePanel('Type');
    var widthPanelM    = makePanel('Width (mm)');
    var depthPanelM    = makePanel('Depth (mm)');
    var installPanelM  = makePanel('Installation');
    var warrantyPanelM = makePanel('Manufacturer Warranty');

    /* Category facet reads the product tags facet, keeps only tags that match a collection handle
       (Powerland's category tags mirror collection handles), and shows the collection title. */
    function categoryItems(items) {
      return items
        .filter(function (it) {
          var h = CATEGORY_TAG_ALIAS[it.value] || it.value;
          return collectionTitles[h] && !CATEGORY_TAG_EXCLUDE[h];
        })
        .map(function (it) {
          var label = collectionTitles[CATEGORY_TAG_ALIAS[it.value] || it.value];
          return Object.assign({}, it, { label: label, highlighted: label });
        });
    }

    var searchClient = algoliasearch(CONFIG.appId, CONFIG.searchApiKey);
    var search = instantsearch({ indexName: CONFIG.indexName, searchClient: searchClient });

    search.addWidgets([
      instantsearch.widgets.configure({ hitsPerPage: CONFIG.hitsPerPage, distinct: true }),

      instantsearch.widgets.stats({
        container: '#algolia-inline-stats',
        templates: {
          text: function (data) {
            return data.nbHits.toLocaleString() + ' results for "<strong>' + data.query + '</strong>"';
          }
        }
      }),

      instantsearch.widgets.hits({
        container: '#algolia-inline-hits',
        templates: {
          item: function (hit, bind) {
            var html = bind.html;
            var components = bind.components;
            var hasSale = hit.compare_at_price && hit.compare_at_price > hit.price;
            var savings  = hasSale ? Math.round(hit.compare_at_price - hit.price) : 0;
            var imgSrc   = hit.image || (hit.images && hit.images[0]) || '';
            var imgSrc2  = (hit.images && hit.images[1]) ? hit.images[1] : imgSrc;
            var vendorKey = handleize(hit.vendor || '');
            var logoUrl = vendorLogos[vendorKey] || '';
            var stickerUrl = 'https://powerland.com.au/cdn/shop/collections/next-day-install-delivery_ad81a13e-2d54-4eb7-8171-53bf4c4c5360_medium.webp?v=1787721429';
            /* Sticker: product must be in Shopify collection 489277980911
               IDs fetched at bootstrap from /collections/next-day-delivery-smart-collection/products.json */
            var hasSticker = !!(stickerProductIds[hit.id] || stickerProductIds[Number(hit.id)]);
            var variantId = (hit.variants && hit.variants[0] && hit.variants[0].id) || hit.variant_id || hit.objectID || '';
            return html`
              <div class="ais-inline-hit-wrap" style="display:flex;flex-direction:column;width:100%;height:100%;">
                <a href="/products/${hit.handle}" class="ais-inline-hit" style="flex:1;">
                  <div class="ais-inline-hit__img-wrap">
                    <img class="ais-main-img" src="${imgSrc}" data-src="${imgSrc}" data-hover="${imgSrc2}" alt="${hit.title}" loading="lazy" />
                    <div class="ais-inline-badge">
                      <span class="ais-inline-badge__price">${fmt(hit.price)}</span>
                      ${hasSale ? html`<span class="ais-inline-badge__was">${fmt(hit.compare_at_price)}</span>` : ''}
                    </div>
                    ${hasSticker ? html`<img src="${stickerUrl}" alt="Next Day Delivery" style="position:absolute;top:4px;left:6px;width:64px !important;height:64px !important;object-fit:contain;z-index:4;" />` : ''}
                  </div>
                  ${hasSale ? html`<div class="ais-inline-save">Save ${fmt(savings)}</div>` : ''}
                  <div class="ais-inline-hit__body">
                    <div class="ais-inline-hit__brand">
                      ${logoUrl ? html`<img src="${logoUrl}" alt="${hit.vendor}" class="ais-inline-vendor-logo" />` : hit.vendor || ''}
                    </div>
                    <div class="ais-inline-hit__title">
                      ${components.Highlight({ hit: hit, attribute: 'title' })}
                    </div>
                  </div>
                </a>
                <button class="ais-inline-atc" data-variant-id="${variantId}">Add to Cart</button>
              </div>
            `;
          },
          empty: function (data, bind) {
            var html = bind.html;
            return html`<p class="ais-inline-no-results">No products found for "<strong>${data.query}</strong>".</p>`;
          }
        }
      }),

      /* Desktop facets */
      buildPriceRangeWidget('ais-price-range'),
      brandPanel({ container: '#ais-facets-vendor', attribute: 'vendor', sortBy: ['count:desc'], limit: 7, showMore: true, showMoreLimit: 25 }),
      categoryPanel({ container: '#ais-facets-category', attribute: 'tags', sortBy: ['count:desc'], limit: 60, showMore: true, showMoreLimit: 120, transformItems: categoryItems }),
      typePanel({ container: '#ais-facets-type', attribute: 'product_type', sortBy: ['count:desc'], limit: 7, showMore: true, showMoreLimit: 25 }),
      widthPanel({ container: '#ais-facets-width', attribute: 'meta.custom.width_mm', sortBy: ['name:asc'], limit: 8, showMore: true, showMoreLimit: 30 }),
      depthPanel({ container: '#ais-facets-depth', attribute: 'meta.custom.depth_mm', sortBy: ['name:asc'], limit: 8, showMore: true, showMoreLimit: 30 }),
      installPanel({ container: '#ais-facets-installation', attribute: 'meta.custom.installation', sortBy: ['count:desc'], limit: 8 }),
      warrantyPanel({ container: '#ais-facets-warranty', attribute: 'meta.custom.manufacturer-warranty', sortBy: ['name:asc'], limit: 8 }),

      /* Mobile facets */
      buildPriceRangeWidget('ais-price-range-mobile'),
      brandPanelM({ container: '#ais-facets-vendor-mobile', attribute: 'vendor', sortBy: ['count:desc'], limit: 7, showMore: true, showMoreLimit: 25 }),
      categoryPanelM({ container: '#ais-facets-category-mobile', attribute: 'tags', sortBy: ['count:desc'], limit: 60, showMore: true, showMoreLimit: 120, transformItems: categoryItems }),
      typePanelM({ container: '#ais-facets-type-mobile', attribute: 'product_type', sortBy: ['count:desc'], limit: 7, showMore: true, showMoreLimit: 25 }),
      widthPanelM({ container: '#ais-facets-width-mobile', attribute: 'meta.custom.width_mm', sortBy: ['name:asc'], limit: 8, showMore: true, showMoreLimit: 30 }),
      depthPanelM({ container: '#ais-facets-depth-mobile', attribute: 'meta.custom.depth_mm', sortBy: ['name:asc'], limit: 8, showMore: true, showMoreLimit: 30 }),
      installPanelM({ container: '#ais-facets-installation-mobile', attribute: 'meta.custom.installation', sortBy: ['count:desc'], limit: 8 }),
      warrantyPanelM({ container: '#ais-facets-warranty-mobile', attribute: 'meta.custom.manufacturer-warranty', sortBy: ['name:asc'], limit: 8 }),

      instantsearch.widgets.pagination({ container: '#algolia-inline-pagination', padding: 2 })
    ]);

    search.start();

    /* ── Wire up accordion after first render ── */
    search.on('render', function() {
      setupAccordion(panel.querySelector('#algolia-inline-facets'));
      setupAccordion(panel.querySelector('#ais-filter-drawer__panel'));
    });

    /* ── Restore from URL ── */
    var urlQ = new URLSearchParams(window.location.search).get('q');
    if (urlQ) {
      document.querySelectorAll(SEARCH_SELECTOR).forEach(function(inp) { inp.value = urlQ; });
      showInline(urlQ);
    }

    var isActive = false;

    function showInline(query) {
      /* Show results div (was hidden on mobile until first keystroke) */
      var resDiv = panel.querySelector('#algolia-inline-results');
      if (resDiv) resDiv.style.display = '';

      search.helper.setQuery(query).search();
      if (!isActive) {
        var isMobile = window.innerWidth <= 768;
        if (!isMobile) { mainContent.style.display = 'none'; }
        panel.classList.add('ais-active');
        document.body.classList.add('ais-inline-on');
        isActive = true;
        if (isMobile) {
          if (!mobileOverlay.contains(panel)) mobileOverlay.appendChild(panel);
          mobileOverlay.classList.add('ais-open');
        }
      }
      if (window.innerWidth > 768) {
        var url = new URL(window.location.href);
        url.searchParams.set('q', query);
        window.history.replaceState({}, '', url.toString());
      }
    }

    function hideInline() {
      if (isActive) {
        _mobileRefocusAllowed = false;
        mainContent.style.display = '';
        /* Reset results visibility for next open */
        var resDiv = panel.querySelector('#algolia-inline-results');
        if (resDiv) resDiv.style.display = '';
        panel.classList.remove('ais-active');
        panel.style.top = '';
        mobileSearchInput.blur();
        mobileSearchInput.value = '';
        document.body.classList.remove('ais-inline-on');
        document.body.classList.remove('ais-mobile-on');
        document.body.style.overflow = '';
        closeDrawer();
        mobileOverlay.classList.remove('ais-open');
        if (panelOriginalParent && panel.parentNode !== panelOriginalParent) {
          panelOriginalParent.appendChild(panel);
        }
        isActive = false;
        setTimeout(function() { _mobileRefocusAllowed = true; }, 200);
        var url = new URL(window.location.href);
        url.searchParams.delete('q');
        window.history.replaceState({}, '', url.toString());
      }
    }

    /* ── Sort ── */
    var sortSel = document.createElement('select');
    sortSel.id = 'ais-sort-select';
    sortSel.innerHTML =
      '<option value="">Sort: Relevance</option>' +
      '<option value="price-asc">Price: Low to High</option>' +
      '<option value="price-desc">Price: High to Low</option>';
    panel.querySelector('#ais-sort-by').appendChild(sortSel);

    sortSel.addEventListener('change', function () {
      var val = this.value;
      var list = panel.querySelector('#algolia-inline-hits .ais-Hits-list');
      if (!list) return;
      var items = Array.prototype.slice.call(list.children);
      items.sort(function (a, b) {
        var pa = parseFloat((a.querySelector('.ais-inline-badge__price') || {}).textContent.replace(/[^0-9.]/g, '') || 0);
        var pb = parseFloat((b.querySelector('.ais-inline-badge__price') || {}).textContent.replace(/[^0-9.]/g, '') || 0);
        if (val === 'price-asc') return pa - pb;
        if (val === 'price-desc') return pb - pa;
        return 0;
      });
      items.forEach(function (item) { list.appendChild(item); });
    });
    search.on('render', function () { if (sortSel.value) sortSel.dispatchEvent(new Event('change')); });

    mobileCloseBtn && mobileCloseBtn.addEventListener('click', function () {
      document.querySelectorAll(SEARCH_SELECTOR).forEach(function (inp) { inp.value = ''; });
      hideInline();
    });
    desktopCloseBtn && desktopCloseBtn.addEventListener('click', function () {
      document.querySelectorAll(SEARCH_SELECTOR).forEach(function (inp) { inp.value = ''; });
      hideInline();
    });

    /* ── Input delegation ── */
    var timer;
    document.addEventListener('input', function (e) {
      var isMobileInput = (e.target === mobileSearchInput);
      if (!isMobileInput && !e.target.matches(SEARCH_SELECTOR)) return;
      var q = e.target.value.trim();
      if (q.length > 0) document.body.classList.add('ais-inline-on');
      clearTimeout(timer);
      var captured = q;
      timer = setTimeout(function () {
        if (captured.length > 0) {
          showInline(captured);
        } else if (isMobileInput) {
          /* Mobile: empty input via backspace — keep overlay open, just hide results */
          var resDiv = panel.querySelector('#algolia-inline-results');
          if (resDiv) resDiv.style.display = 'none';
        } else {
          hideInline();
        }
      }, 200);
      if (!isMobileInput) attachClearBtn();
    }, true);

    document.addEventListener('keydown', function (e) {
      if (!e.target.matches(SEARCH_SELECTOR)) return;
      if (e.key === 'Escape') { e.target.value = ''; hideInline(); }
      if (e.key === 'Enter' && isActive) { e.preventDefault(); }
    }, true);

    document.addEventListener('mouseover', function (e) {
      var wrap = e.target.closest('.ais-inline-hit__img-wrap');
      if (!wrap) return;
      var img = wrap.querySelector('img.ais-main-img');
      if (img && img.dataset.hover && img.dataset.hover !== img.dataset.src) img.src = img.dataset.hover;
    });
    document.addEventListener('mouseout', function (e) {
      var wrap = e.target.closest('.ais-inline-hit__img-wrap');
      if (!wrap || wrap.contains(e.relatedTarget)) return;
      var img = wrap.querySelector('img.ais-main-img');
      if (img) img.src = img.dataset.src;
    });

    document.querySelectorAll('.search-modal__close-button,[data-close-search],.predictive-search__close')
      .forEach(function (btn) { btn.addEventListener('click', hideInline); });

    function attachClearBtn() {
      var clearBtn = document.querySelector('[type="reset"],.search__reset,button[aria-label="Clear"],.search-modal__close-button,[data-predictive-search-close]');
      if (clearBtn && !clearBtn._algoliaInlineBound) {
        clearBtn._algoliaInlineBound = true;
        clearBtn.addEventListener('click', function () { setTimeout(hideInline, 50); });
      }
    }
    attachClearBtn();

    document.addEventListener('click', function (e) {
      var btn = e.target.closest('.ais-inline-atc');
      if (!btn) return;
      e.preventDefault(); e.stopPropagation();
      addToCart(btn.getAttribute('data-variant-id'), btn);
    });

    console.log('[Algolia Inline Search] Ready');
  }

  function bootstrap() {
    injectStyles();
    loadNoUiSlider(function () {
      fetchStickerCollection(function () {
        fetchVendorLogos(function () { setTimeout(init, 600); });
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootstrap);
  } else {
    bootstrap();
  }

})();